import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import StickyFooter from './StickyFooter.jsx';

function Layout({ children }) {
  const { schoolId } = useParams();
  const location = useLocation();
  
  // For specific school routes, hardcode the schoolId
  let finalSchoolId = schoolId;
  if (location.pathname.startsWith('/alipurduar')) {
    finalSchoolId = 'alipurduar';
  }
  if (location.pathname.startsWith('/bolpur')) {
    finalSchoolId = 'bolpur';
  }
  if (location.pathname.startsWith('/coochbehar')) {
    finalSchoolId = 'coochbehar';
  }
  if (location.pathname.startsWith('/durgapur')) {
    finalSchoolId = 'durgapur';
  }
  if (location.pathname.startsWith('/falakata')) {
    finalSchoolId = 'falakata';
  }
  if (location.pathname.startsWith('/gangarampur')) {
    finalSchoolId = 'gangarampur';
  }
  if (location.pathname.startsWith('/hoogly')) {
    finalSchoolId = 'hoogly';
  }
  if (location.pathname.startsWith('/jalpaiguri')) {
    finalSchoolId = 'jalpaiguri';
  }
  if (location.pathname.startsWith('/kolaghat')) {
    finalSchoolId = 'kolaghat';
  }
  if (location.pathname.startsWith('/krishnanagar')) {
    finalSchoolId = 'krishnanagar';
  }
  if (location.pathname.startsWith('/midnapore')) {
    finalSchoolId = 'midnapore';
  }
  if (location.pathname.startsWith('/nabadwip')) {
    finalSchoolId = 'nabadwip';
  }
  if (location.pathname.startsWith('/raiganj')) {
    finalSchoolId = 'raiganj';
  }
  if (location.pathname.startsWith('/raniganj')) {
    finalSchoolId = 'raniganj';
  }
  if (location.pathname.startsWith('/siliguri')) {
    finalSchoolId = 'siliguri';
  }

  return (
    <>
      <Header schoolId={finalSchoolId} />
      <main>{children}</main>
      <StickyFooter />
      <Footer />
    </>
  );
}

export default Layout;